let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bfSAg")).then(() => parcelRequire('ln9R3'));